export default function eventInfo(api){
    api.provideOMFETopic('subscribeToEventInfo', 'unsubscribeFromEventInfo', {
        topicName : ({ucsOperatorId, apiVersion, lang, matchId, eventInfoType, eventPartId}) =>
            `/sports/${(apiVersion && ucsOperatorId && apiVersion >= 1 && ucsOperatorId + '/') || ''}${lang || 'en'}/${matchId || 0}/eventInfo${eventInfoType && `/${eventInfoType}` || ''}${eventPartId && `/${eventPartId}` || ''}`,
    });
}



// WEBPACK FOOTER //
// ./src/OMFECore/enhanced-webapi/api-sports/sub-event-info.js